import { AppState } from './types';
import {
    PEProfitPrognose,
    PlanungsBasisDatenTyp,
    PlanungsSzenario,
    createDefaultPEProfitPrognose,
} from '../types/peProfit';

export type PeProfitWorkspace = 'peProfit' | 'planungsAnalyse';

/** UI-Selector: liest Prognose/Archiv des aktiven Workspace */
export const selectActivePeProfitWorkspace = (state: AppState) => {
    const ws: PeProfitWorkspace =
        state.peProfitWorkspace === 'planungsAnalyse' ? 'planungsAnalyse' : 'peProfit';
    if (ws === 'planungsAnalyse') {
        const memory = state.planungsAnalyseArchiv;
        const fromClient = state.clientData?.planungsAnalyseArchiv;
        const planungsArchiv: PlanungsSzenario[] =
            Array.isArray(memory) && memory.length > 0
                ? memory
                : Array.isArray(fromClient) && fromClient.length > 0
                  ? fromClient
                  : Array.isArray(memory)
                    ? memory
                    : [];
        return {
            workspace: ws,
            prognose: (state.planungsAnalysePrognose ??
                createDefaultPEProfitPrognose()) as PEProfitPrognose,
            activeSzenarioId: state.planungsAnalyseActiveSzenarioId ?? null,
            planungsArchiv,
            basisDatenTyp: (state.planungsAnalyseBasisDatenTyp ??
                'start') as PlanungsBasisDatenTyp,
        };
    }
    const memory = state.planungsArchiv;
    const fromClient = state.clientData?.planungsArchiv;
    const planungsArchiv: PlanungsSzenario[] =
        Array.isArray(memory) && memory.length > 0
            ? memory
            : Array.isArray(fromClient) && fromClient.length > 0
              ? fromClient
              : Array.isArray(memory)
                ? memory
                : [];
    return {
        workspace: ws,
        prognose: (state.peProfitPrognose ?? createDefaultPEProfitPrognose()) as PEProfitPrognose,
        activeSzenarioId: state.activeSzenarioId ?? null,
        planungsArchiv,
        basisDatenTyp: (state.peProfitBasisDatenTyp ?? 'start') as PlanungsBasisDatenTyp,
    };
};
